import React from "react";
import "./Marker.css";

const Marker = () => {
  return <div className="marker" />;
};

export default Marker;
